import Form from "components/Form";
import BoldTypography from "components/BoldTypography";
import {withStyles} from "@material-ui/core";
import Tr from "translations/Translations";
import Button from "components/Button";
import React, {useState} from "react";
import TextInput from "components/TextInput";
import UploadFile from "components/UploadFile";
import {approvalDecisionValidationSchema} from "./constants/validationSchema";
import GridBlock from "components/GridBlock";
import {canApprove, canMasterApprove, canMasterReject} from "./lib/ApprovalAccessUtils";
import Confirm from "components/popup/confirm/Confirm";
import PropTypes from "prop-types";

const style = theme => ({
    root: {
        border: `solid 2px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2),
        marginTop: theme.spacing()
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    mr: {
        marginRight: theme.spacing(1)
    },
    approvalStage: {
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    buttons: {
        marginTop: theme.spacing()
    },
    uploadLabel: {
        fontWeight: theme.typography.fontWeightRegular
    }
});

function ApprovalDecision(
    {
        approval,
        stage,
        loggedUser,
        sendDecision,
        classes,
        working
    }) {

    const [masterApproveOpen, setMasterApproveOpen] = useState(false);
    const [masterRejectOpen, setMasterRejectOpen] = useState(false);

    const decisionMade = (decision, formikProps) => {
        formikProps.setFieldValue('decision', decision, true).then(() => {
            formikProps.submitForm();
        })
    }

    return (
        <>
            <Form
                onSubmit={sendDecision}
                initialValues={({
                    identity: approval.identity,
                    stageId: stage.identity,
                    decision: null,
                    approverComment: null,
                    approverAttachments: [],
                    assigneeComment: approval.assignee.comment
                })}
                id={'Approval'}
                validationSchema={approvalDecisionValidationSchema(stage)}
                afterSubmitFunc={() => {
                }}
            >
                {(formikProps) => {
                    return (
                        <>
                            <BoldTypography className={classes.ml2}>{approval.name}</BoldTypography>
                            <div className={classes.root}>
                                <BoldTypography className={classes.approvalStage}>{stage.name}</BoldTypography>
                                {!!approval.assignee.comment && <TextInput
                                    id={`assigneeComment`}
                                    label={Tr('selectApproversAssigneeComment')}
                                    formikProps={formikProps}
                                    multiline
                                    disabled
                                />}
                                <TextInput
                                    id={`approverComment`}
                                    label={Tr('approverComment')}
                                    formikProps={formikProps}
                                    limit={255}
                                    multiline
                                    required={stage.acceptRequireComment}
                                />
                                {approval.approversAttachments && <UploadFile
                                    id='approverAttachments'
                                    formikProps={formikProps}
                                    label={Tr("approverAttachments")}
                                    disabled={!approval.formVisible}
                                    labelClassName={classes.uploadLabel}
                                />}
                            </div>
                            <GridBlock direction='row-reverse' className={classes.buttons}>
                                {canMasterReject(approval, stage) && <Button
                                    disabled={!approval.formVisible || working}
                                    onClick={() => setMasterRejectOpen(true)}
                                    className={classes.mr}
                                    variant={'outlined'}
                                >
                                    {Tr('approverMasterReject')}
                                </Button>}
                                {canMasterApprove(approval, stage) && <Button
                                    disabled={!approval.formVisible || working}
                                    onClick={() => setMasterApproveOpen(true)}
                                    className={classes.mr}
                                    variant={'outlined'}
                                >
                                    {Tr('approverMasterApprove')}
                                </Button>}
                                {canApprove(stage, loggedUser) && <Button
                                    disabled={!approval.formVisible || working}
                                    onClick={() => decisionMade('reject', formikProps)}
                                    className={classes.mr}
                                >
                                    {Tr('approverReject')}
                                </Button>}
                                {canApprove(stage, loggedUser) && <Button
                                    disabled={!approval.formVisible || working}
                                    onClick={() => decisionMade('accept', formikProps)}
                                    className={classes.mr}
                                >
                                    {Tr('approverApprove')}
                                </Button>}
                            </GridBlock>
                            <Confirm
                                open={masterApproveOpen}
                                onConfirm={() => {
                                    decisionMade('masterApprove', formikProps);
                                    setMasterApproveOpen(false);
                                }}
                                onCancel={() => setMasterApproveOpen(false)}
                                confirmText="approverMasterApprove_confirm"
                            />
                            <Confirm
                                open={masterRejectOpen}
                                onConfirm={() => {
                                    decisionMade('masterReject', formikProps);
                                    setMasterRejectOpen(false);
                                }}
                                onCancel={() => setMasterRejectOpen(false)}
                                confirmText="approverMasterReject_confirm"
                            />
                        </>
                    )
                }}
            </Form>
        </>);
}

ApprovalDecision.propTypes = {
    approval: PropTypes.object,
    stage: PropTypes.object,
    loggedUser: PropTypes.object,
    sendDecision: PropTypes.func,
    classes: PropTypes.any,
    working: PropTypes.bool
}

export default withStyles(style)(ApprovalDecision);